var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"song-cover",style:({ width: _vm.size + 'px', height: _vm.size + 'px' })},[(_vm.coverUrl && !_vm.hasError)?_c('img',{staticClass:"song-cover-image",attrs:{"src":_vm.coverUrl,"alt":_vm.alt},on:{"error":_vm.handleError}}):_c('img',{staticClass:"song-cover-image",attrs:{"src":_vm.defaultCover,"alt":_vm.alt}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff3a4b7a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/SongCover.vue
// module id = null
// module chunks = 